import { SaveStore, SavedSettings, defaultSettings } from './SaveStore';

export class GameSettings {
  private static settings: SavedSettings = SaveStore.loadSettings();

  static getAll(): SavedSettings {
    return { ...this.settings };
  }

  static get<K extends keyof SavedSettings>(key: K): SavedSettings[K] {
    return this.settings[key];
  }

  static set<K extends keyof SavedSettings>(key: K, value: SavedSettings[K]) {
    this.settings = { ...this.settings, [key]: value };
    SaveStore.saveSettings(this.settings);
  }

  static reset() {
    this.settings = { ...defaultSettings };
    SaveStore.saveSettings(this.settings);
  }

  static getSpeedMultiplier() {
    return this.settings.alwaysRun ? 1.35 : 1;
  }

  static getTextSpeedMs() {
    const speed = this.settings.textSpeed;
    if (speed >= 1.5) return 10;
    if (speed >= 1.25) return 16;
    if (speed >= 1) return 24;
    return 36;
  }
}
